

import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
Tab,
TabItem,
Loading,
ViewBox,
XHeader
},
data () {
return {
}
},
computed: {
route () {
return this.$store.getters.route
}
},
methods: {
changePage (page) {
console.log()
}
}
}



// WEBPACK FOOTER //
// ./src/pages/components/NavBar.vue